// 待付款申请列表tabs
export const waitPaymentApplicationList = [{
  title: '待审批',
  name: '1'
},
{
  title: '我的待审批',
  name: '2'
},
{
  title: '我的已审批未完结',
  name: '3'
},
{
  title: '我的已审批已完结',
  name: '4'
}
]
// 待处理申请列表tabs
export const dealPaymentApplicationList = [{
  title: '待处理',
  name: '1'
},
{
  title: '我的待处理',
  name: '2'
},
{
  title: '我的已处理',
  name: '3'
}
]
// 待付款申请列表tabs
export const bankPaymentApplicationList = [{
  title: '银行转账',
  name: '1'
},
{
  title: '承兑汇票',
  name: '0'
}
]
// 待付款申请列表tabs
export const usebillList = [{
  title: '可用汇票',
  name: '1'
},
{
  title: '不可用汇票',
  name: '0'
}
]
// 银行列表tabs
export const bankCollectionList = [{
  title: '待处理',
  name: '1'
},
{
  title: '我的待处理',
  name: '2'
},
{
  title: '收款记录',
  name: '3'
},
{
  title: '审核不通过',
  name: '4'
}
]
// 承兑汇票收款管理tabs
export const acceeptList = [{
  title: '待审核',
  name: '1'
},
{
  title: '我的待审核',
  name: '2'
},
{
  title: '我的已审核',
  name: '3'
}
]
export const waitFeedbackEnquiryList = [{
  label: '付款编号',
  value: 'payNumber'
},
{
  label: '付款类型',
  value: 'payType'
},
{
  label: '账户名称',
  value: 'receiptName'
},
{
  label: '银行账号',
  value: 'receiptBankNumber'
},
{
  label: '申请人',
  value: 'staffCnName'
},
{
  label: '所属部门',
  value: 'orgName'
}
]
// 银行转账列表选项
export const bankCollectionOptionList = [{
  label: '付款编号',
  value: 'payNumber'
},
{
  label: '付款类型',
  value: 'payType'
},
{
  label: '付款金额',
  value: 'payAmount'
},
{
  label: '账户名称',
  value: 'receiptName'
},
{
  label: '银行账号',
  value: 'receiptBankNumber'
},
{
  label: '开户行',
  value: 'receiptOpenNumber'
},
{
  label: '申请人',
  value: 'staffCnName'
},
{
  label: '所属部门',
  value: 'orgName'
}
]
// 承兑汇票列表选项
export const bankDraftList = [{
  label: '付款编号',
  value: 'payNumber'
},
{
  label: '付款类型',
  value: 'payType'
},
{
  label: '付款金额',
  value: 'payAmount'
},
{
  label: '付款方式',
  value: 'payMethod'
},
{
  label: '承兑票号',
  value: 'billNumber'
},
{
  label: '票据金额',
  value: 'billMoney'
},
{
  label: '出票单位',
  value: 'billCompany'
},
{
  label: '出票行',
  value: 'billBank'
},
{
  label: '出票日期',
  value: 'billDate'
},
{
  label: '到期日期',
  value: 'billEnddate'
},
{
  label: '申请人',
  value: 'staffCnName'
},
{
  label: '所属部门',
  value: 'orgName'
}
]
// 收款记录
export const bankDrafmonery = [{
  label: '收款编号',
  value: 'receiptNumber'
},
{
  label: '客户/供应商名称',
  value: 'cusName'
},
{
  label: '承兑票号',
  value: 'billNumber'
},
{
  label: '票据金额',
  value: 'billMoney'
},
{
  label: '出票单位',
  value: 'billCompany'
},
{
  label: '出票行',
  value: 'billBank'
},
{
  label: '出票日期',
  value: 'billDate'
},
{
  label: '到期日期',
  value: 'billEnddate'
},
{
  label: '收款类型',
  value: 'receiptType'
},
// {
//   label: '收款方式',
//   value: 'receiptClass'
// },
{
  label: '提交人',
  value: 'createUser'
},
{
  label: '提交时间',
  value: 'createDate'
}
]
// 其他管理列表选项
export const otherCollectionOptionList = [{
  label: '收款编号',
  value: 'receiptNumber'
}, {
  label: '供应商名称',
  value: 'receiptBankNumber'
},
{
  label: '付款人银行账号',
  value: 'payBankNumber'
},
{
  label: '付款人名称',
  value: 'payName'
},
{
  label: '开户行名称',
  value: 'payOpenBank'
},
{
  label: '收款金额',
  value: 'amount'
},
{
  label: '收款类型',
  value: 'receiptType'
},
{
  label: '收款方式',
  value: 'receiptClass'
},
{
  label: '提交人',
  value: 'createUser'
},
{
  label: '提交时间',
  value: 'createDate'
}
]
// 承兑汇票收款列表选项
export const acceptDraftList = [{
  label: '客户/供应商名称',
  value: 'cusName'
},
{
  label: '承兑汇票',
  value: 'billNumber'
},
{
  label: '票据金额',
  value: 'billMoney'
},
{
  label: '出票单位',
  value: 'billCompany'
},
{
  label: '出票行',
  value: 'billBank'
},
{
  label: '出票日期',
  value: 'billDate'
},
{
  label: '到期日期',
  value: 'billEnddate'
},
{
  label: '收款类型',
  value: 'receiptType'
},
{
  label: '收款方式',
  value: 'receiptClass'
},
{
  label: '提交人',
  value: 'createUser'
},
{
  label: '提交时间',
  value: 'createDate'
}
]
// 承兑汇票tabs
export const acceptDraftManageList = [{
  title: '可用汇票',
  name: '1'
},
{
  title: '不可用汇票',
  name: '2'
}
]
// 待处理申请列表tabs
export const billList = [{
  label: '票据号码',
  name: 'billNumber'
},
{
  label: '出票单位',
  name: 'billCompany'
},
{
  label: '出票行',
  name: 'billBank'
}
]
// 可用汇票列表选项
export const usedbillList = [{
  label: '汇票票号',
  value: 'billNumber'
},
{
  label: '汇票金额',
  value: 'billMoney'
},
{
  label: '状态',
  value: 'billState'
},
{
  label: '出票单位',
  value: 'billCompany'
},
{
  label: '出票行',
  value: 'billBank'
},
{
  label: '出票日期',
  value: 'billDate'
},
{
  label: '到期日期',
  value: 'billEnddate'
},
{
  label: '到期天数',
  value: 'billDays'
},
{
  label: '使用对象',
  value: 'cbName'
},
{
  label: '状态',
  value: 'flag'
},
{
  label: '来源',
  value: 'fromType'
},
{
  label: '添加人',
  value: 'createUser'
}
]
// 不可用汇票列表选项
export const nobillList = [{
  label: '汇票票号',
  value: 'billNumber'
},
{
  label: '汇票金额',
  value: 'billMoney'
},
{
  label: '出票单位',
  value: 'billCompany'
},
{
  label: '出票行',
  value: 'billBank'
},
{
  label: '出票日期',
  value: 'billDate'
},
{
  label: '到期日期',
  value: 'billEnddate'
},
{
  label: '状态',
  value: 'billState'
},
{
  label: '来源',
  value: 'fromType'
},
{
  label: '添加人',
  value: 'createUser'
},
{
  label: '添加日期',
  value: 'createDate'
}
]
// 坏账管理选项
export const badDebte = [{
  label: '坏账申请编号',
  value: 'badNumber'
},
{
  label: '合同编号',
  value: 'orderContractNumber'
},
{
  label: '公司名称',
  value: 'cusName'
},
{
  label: '坏账金额',
  value: 'badCount'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
}]
// 待处理申请列表tabs
export const financeList = [{
  title: '待审核开票申请',
  name: '1'
},
{
  title: '待处理开票申请',
  name: '2'
},
{
  title: '我的待处理开票申请',
  name: '3'
},
{
  title: '开票记录',
  name: '4'
}
]
// 财务开票列表tabs
export const financebillList = [{
  label: '开票编号',
  value: 'megerCode'
},
{
  label: '公司名称',
  value: 'cusName'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
}
]

export const findTypeTwo = [{
  label: '开票编号',
  value: 'megerCode'
},
{
  label: '公司名称',
  value: 'cusName'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
},
{
  label: '认领人',
  value: 'processSecUser'
},
{
  label: '认领时间',
  value: 'processSecDate'
}
]

export const findTypeTree = [{
  label: '开票编号',
  value: 'megerCode'
},
{
  label: '公司名称',
  value: 'cusName'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '开票类型',
  value: 'invoiceType'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
},
{
  label: '认领时间',
  value: 'processSecDate'
}
]

export const findTypeFore = [{
  label: '开票编号',
  value: 'megerCode'
},
{
  label: '公司名称',
  value: 'cusName'
},
{
  label: '发票编号',
  value: 'invoiceCode'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
},
{
  label: '开票状态',
  value: 'state'
},
{
  label: '处理人',
  value: 'receivePeople'
},
{
  label: '处理时间',
  value: 'processDate'
}
]
// 收票列表tabs
export const financeChecktabs = [{
  title: '待处理收票申请',
  name: '1'
},
{
  title: '我的待处理收票申请',
  name: '2'
},
{
  title: '收票记录',
  name: '3'
}
]
// 财务开票列表tabs
export const financeCheckList = [{
  label: '收票编号',
  value: 'invoiceReceiveNumber'
},
{
  label: '公司名称',
  value: 'invoiceReceiveCompany'
},
{
  label: '发票编号',
  value: 'invoiceNumber'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
}
]
export const findTapTwo = [{
  label: '收票编号',
  value: 'invoiceReceiveNumber'
},
{
  label: '公司名称',
  value: 'invoiceReceiveCompany'
},
{
  label: '发票编号',
  value: 'invoiceNumber'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
},
{
  label: '认领时间',
  value: 'processDate'
}
]
export const findTapThere = [{
  label: '收票编号',
  value: 'invoiceReceiveNumber'
},
{
  label: '公司名称',
  value: 'invoiceReceiveCompany'
},
{
  label: '发票编号',
  value: 'invoiceNumber'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请收票时间',
  value: 'epic'
},
{
  label: '收票状态',
  value: 'invoiceState'
},
{
  label: '收票时间',
  value: 'invoiceReceiveDate'
}
]
// 普通发票退票管理tabs
export const commontabs = [{
  title: '待核审退票申请',
  name: '1'
},
{
  title: '待处理退票申请',
  name: '2'
},
{
  title: '我的待处理退票申请',
  name: '3'
},
{
  title: '退票记录',
  name: '4'
}
]
// 财务开票列表tabs
export const commonList = [{
  label: '退票编号',
  value: 'subNumber'
},
{
  label: '公司名称',
  value: 'cusName'
},
{
  label: '发票编号',
  value: 'megerCode'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
}
]
// 财务开票列表tabs
export const redcommonList = [{
  label: '退票编号',
  value: 'subNumber'
},
{
  label: '公司名称',
  value: 'cusName'
},
{
  label: '发票编号',
  value: 'taxNumber'
},
{
  label: '发票金额',
  value: 'amount'
},
{
  label: '发票类型',
  value: 'invoiceType'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请人',
  value: 'createUser'
},

{
  label: '申请时间',
  value: 'invoiceDate'
}
]
// 余额管理列表tabs
export const balanceList = [{
  title: '客户余额',
  name: '1'
},
{
  title: '供应商余额',
  name: '2'
}
]
// 待处理申请列表tabs
export const balanceMList = [{
  label: '客户名称',
  value: 'cusName'
},
{
  label: '账户余额',
  value: 'accountBalance'
},
{
  label: '当前负责人',
  value: 'staffCnName'
}
]
// 待处理申请列表tabs
export const payMList = [{
  label: '供应商名称',
  value: 'cusName'
},
{
  label: '扣款金额',
  value: 'deductionAmount'
},
{
  label: '当前负责人',
  value: 'staffCnName'
}
]
// 供应商列表tabs
export const givetabs = [{
  label: '供应商名称',
  value: 'cusName'
},
{
  label: '账户余额',
  value: 'accountBalance'
},
{
  label: '当前负责人',
  value: 'staffCnName'
}
]
// 供应商列表tabs  notes
export const customtabs = [{
  label: '交易金额',
  value: 'amount'
},
{
  label: '收支类型',
  value: 'tradeType'
},
{
  label: '交易时间',
  value: 'tradeDate'
}
]
// 财务管理设置tabs
export const seteList = [{
  title: '税收分类编码&税率',
  name: '2'
// },
// {
//   title: '开票配置',
//   name: '1'
}
]
// 财务管理设置tabs
export const setetabs = [{
  label: '二级分类名称',
  value: 'classTwo'
},
{
  label: '三级分类名称',
  value: 'classType'
},
{
  label: '税率',
  value: 'taxpoint'
},
{
  label: '最后更新时间',
  value: 'editDate'
}
]
export const mateList = [{
  title: '已匹配',
  name: '1'
},
{
  title: '未匹配',
  name: '0'
}
]
// 欠款客户
export const havetabs = [{
  label: '客户名称',
  value: 'cusName'
},
{
  label: '客户编号',
  value: 'cusCode'
},
{
  label: '当前负责人',
  value: 'staffCnName'
},
{
  label: '所属部门',
  value: 'orgName'
}
]
export const cPayType = [{
  label: '客户提现',
  value: 1
}, {
  label: '采购付款',
  value: 2
}, {
  label: '供应商充值',
  value: 3
}, {
  label: '退货罚没金',
  value: 4
}, {
  label: '维修付款',
  value: 5
}, {
  label: '采购退货罚款',
  value: 6
}]
/**
 * 财务搜索
 * */
// 待审核付款申请
export const waitFeedbackEnquiryListex = [{
  label: '付款编号',
  value: 'payNumber'
},
{
  label: '付款类型',
  value: 'payType'
},
{
  label: '申请付款金额',
  value: 'amount'
},
{
  label: '申请人',
  value: 'staffCnName'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
}
]
// 待处理付款申请
export const waitDisposePayApplyListex = [{
  label: '付款编号',
  value: 'payNumber'
},
{
  label: '付款类型',
  value: 'payType'
},
{
  label: '付款金额',
  value: 'amount'
},
{
  label: '账户名称',
  value: 'receiptName'
},
{
  label: '银行账号',
  value: 'bankCode'
},
{
  label: '开户行',
  value: 'bankName'
},
{
  label: '申请人',
  value: 'createUser'
},
{
  label: '所属部门',
  value: 'orgName'
},
{
  label: '申请时间',
  value: 'createDate'
}]

// 银行对账单首款管理
export const bankCollectionListex = [{
  label: '收款编号',
  value: 'receiptNumber'
},
{
  label: '付款人银行账号',
  value: 'payBankNumber'
},
{
  label: '付款人账户名',
  value: 'payName'
},
{
  label: '收款人银行账号',
  value: 'receiptBankNumber'
},
{
  label: '收款人账户名',
  value: 'receiptName'
},
{
  label: '交易流水号',
  value: 'flowCode'
},
{
  label: '收款金额',
  value: 'receiptMoney'
}]

export const payState = [{
  label: '审核中',
  value: 1
}, {
  label: '待处理',
  value: 2
}, {
  label: '审核不通过',
  value: 3
}, {
  label: '审核不通过（退回修改）',
  value: 4
}, {
  label: '付款成功',
  value: 5
}, {
  label: '付款失败',
  value: 6
}]
